export const NUM_IN_GROUP = 5;
export const STROKE_COLOR = 'rgb(0, 0, 0)';
export const STROKE_WIDTH = 0.05;
export const V_PADDING = 0.1;
export const H_PADDING = 0.1;
export const RENDER_DEBOUNCE_MS = 50;
export const IMAGE_UPDATE_TIMEOUT_MS = 500;



// WEBPACK FOOTER //
// ./src/components/Constants.js